import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';

import { MessageList } from '../styles';

/**
 * A titled alert listing messages — an export's validation errors, a deploy's warnings.
 * Renders nothing when there are no messages.
 */
const MessageAlert = ({ severity, title, messages }) => {
  if (messages.length === 0) {
    return null;
  }
  return (
    <Alert severity={severity}>
      {title}
      <MessageList>
        {messages.map((message) => <li key={message}>{message}</li>)}
      </MessageList>
    </Alert>
  );
};

MessageAlert.propTypes = {
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  title: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MessageAlert;
